import { gql } from "@apollo/client";

export const GET_DAMAGE_MATRIX_COMPONENT = gql
`query GetDamageMatrixComponent($vehicleId: String!) {
  getDamageMatrixComponent(vehicleId: $vehicleId) {
    s1
    s2
    s3
    s4
    part
    damageType
  }
}
`